<div class="mt-5">
  <form (ngSubmit)="ngSubmit()" [formGroup]="formData">
    <div class="baseMainFields">
      <div class="mainFields">
        <div class="col-7">
          <label class="tagReq">What form do you want to fill ?</label>
          <ng-select
            formControlName="formType"
            placeholder="Type or select an option">
            <ng-option *ngFor="let elem of formTypes" [value]="elem.id">
              <div>
                {{ elem.name }}
              </div>
            </ng-option>
          </ng-select>
          <div
            class="mt-2"
            *ngIf="submit && form.formType.errors"
            style="font-size: 80%; color: rgb(244 106 106)">
            <span *ngIf="form.formType.errors.required"
              >Please provide a valid form type.</span
            >
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
